var __rspack_ns_object = JSON.parse('{"Load files":"Charger des fichiers","Load folders":"Charger des dossiers"}')